// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `circle {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.moki_wrapper {
  /*  background: lightblue;*/
  width: 300px;
  height: 300px;
  position: relative; /* 1. Add this. */
}

.moki_outerDiv {
  /*background: red;*/
  height: 50%;
  width: 50%;
  position: absolute;
  top: 25%; /* 2. Add this. */
  left: 25%; /* 3. Add this. */
}

.moki_innerDiv1 {
  /*background: seagreen;*/
  position: absolute; /* 4. Add this. */
  top: 50%; /* 5. Add this. */
  left: 50%; /* 6. Add this. */
  transform: translate(-50%, -50%); /* 7. Add this. */
  text-align: center; /* 8. Add this if you want the text to be centered. */
}

.moki_innerDiv2 {
  background: rgba(255, 255, 255, 0.5);
  height: 100%;
  top: 50%;
  left: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/ProgressRing/progressRing.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,iBAAiB;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ,EAAE,iBAAiB;EAC3B,SAAS,EAAE,iBAAiB;AAC9B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB,EAAE,iBAAiB;EACrC,QAAQ,EAAE,iBAAiB;EAC3B,SAAS,EAAE,iBAAiB;EAC5B,gCAAgC,EAAE,iBAAiB;EACnD,kBAAkB,EAAE,qDAAqD;AAC3E;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,QAAQ;EACR,SAAS;AACX","sourcesContent":["circle {\n  transition: stroke-dashoffset 0.35s;\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n}\n\n.moki_wrapper {\n  /*  background: lightblue;*/\n  width: 300px;\n  height: 300px;\n  position: relative; /* 1. Add this. */\n}\n\n.moki_outerDiv {\n  /*background: red;*/\n  height: 50%;\n  width: 50%;\n  position: absolute;\n  top: 25%; /* 2. Add this. */\n  left: 25%; /* 3. Add this. */\n}\n\n.moki_innerDiv1 {\n  /*background: seagreen;*/\n  position: absolute; /* 4. Add this. */\n  top: 50%; /* 5. Add this. */\n  left: 50%; /* 6. Add this. */\n  transform: translate(-50%, -50%); /* 7. Add this. */\n  text-align: center; /* 8. Add this if you want the text to be centered. */\n}\n\n.moki_innerDiv2 {\n  background: rgba(255, 255, 255, 0.5);\n  height: 100%;\n  top: 50%;\n  left: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
